import AssignmentForm from './AssignmentForm';

export default AssignmentForm;
